import styled from 'styled-components';

export const CheckoutViewWrapper = styled.div`
  margin: 32px 0;
`;
export const CheckoutMainTitle = styled.h1`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.h5};
`;
export const CheckoutAside = styled.aside``;
export const CheckoutContent = styled.div`
  margin: 27px 0;
`;
export const CouponFormWrapper = styled.form`
  border: 1px solid #8086a4;
  padding: 6px 16px 6px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  margin-bottom: 14px;
`;
export const CouponTitle = styled.h3`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  margin-bottom: 10px;
`;
export const CouponInput = styled.input`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  transition: 0.3s ease all;
  border: none;
  &::placeholder {
    color: ${({ theme }) => theme.colors.lightPurple};
  }
`;
export const SubmitCouponForm = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #8086a4;
`;
